import { ActionType } from './actionTypes'

export function loadCustomersStatsSuccess(stats: { [id: string]: { [id: number]: number } }) {
  return { type: ActionType.LOAD_CUSTOMER_STATS_SUCCESS, stats } as const
}

export type ContractAction = ReturnType<typeof loadCustomersStatsSuccess>
